export const formatBytes = (bytes: number) => {
    if (bytes === 0) return "0 bytes";

    const k = 1024;
    const sizes = ["bytes", "kB", "MB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${(bytes / k ** i).toFixed(0)} ${sizes[i]}`;
};
